import { accorder } from '../plural.js';
export const it = {
    langue: {
        selecteur: 'Lingua',
    },
    coquille: {
        sautContenu: 'Vai al contenuto',
        deconnexion: 'Esci',
        versionInconnue: 'sconosciuta',
        version: (version, horodatage) => `Versione ${version} — build del ${horodatage}`,
        signature: '— Repère, organizzazione e serenità',
    },
    compte: {
        menu: 'Menu',
        monCompte: 'Il mio account',
        options: 'Opzioni',
        aide: 'Aiuto',
        mesDossiers: 'I miei fascicoli',
        nouveauDossier: 'Nuovo fascicolo',
        identiteTitre: 'Il vostro account',
        formule: 'Formula',
        situation: 'Situazione',
        debut: 'Dal',
        echeance: 'Fino al',
        origine: 'Origine',
        origines: {
            stripe: 'Abbonamento pagato',
            code_essai: 'Codice di prova',
            geste: 'Gesto commerciale',
        },
        statuts: {
            none: 'Nessun abbonamento',
            trialing: 'Prova in corso',
            active: 'Attivo',
            past_due: 'Pagamento in attesa',
            canceled: 'Disdetto',
        },
        resiliationProgrammee: 'Il vostro abbonamento terminerà alla fine del periodo in corso.',
        essaiJusquau: (date) => `Prova gratuita fino al ${date}.`,
        accesCouvert: 'La vostra scrittura è aperta grazie alla formula Duo sottoscritta su un fascicolo ' +
            'che condividete. Potete sottoscrivere il vostro abbonamento in qualsiasi momento.',
        accesProfessionnel: 'Scrivete in virtù di un accesso professionale aperto da un genitore, non di un abbonamento.',
        factures: 'Le mie fatture e il mio pagamento',
        ouvertureFactures: 'Apertura…',
        facturesIndisponibles: 'Nessuna fattura: il vostro accesso non deriva da un pagamento con carta.',
        erreurFactures: 'Non è stato possibile aprire la pagina di fatturazione',
        dossiersTitre: 'I vostri fascicoli',
        parent: (rang) => `Genitore ${rang}`,
        placeLibre: 'Posto ancora libero',
        aucunDossier: 'Non avete ancora alcun fascicolo.',
        optionsTitre: 'Opzioni',
        retourPrecedent: 'Indietro',
        apparence: 'Aspetto',
        apparenceAide: '«Automatico» segue l’impostazione del vostro dispositivo: si scurisce la sera senza pensarci.',
        langueTitre: 'Lingua',
        langueAide: 'La lingua dell’applicazione e delle sue e-mail.',
        lectureIA: 'Lettura dei giustificativi',
        lectureIAAide: 'Quando allegate la foto di uno scontrino a una spesa, Repère può leggerla e ' +
            'proporvi importo, data e categoria. La foto è inviata a Mistral, il nostro ' +
            'fornitore europeo di IA, solo a questo scopo, e non vi è conservata. È l’unico dato ' +
            'del vostro fascicolo che esce dai nostri server.',
        lectureIAActive: 'Leggere i miei giustificativi',
        lectureIAInactive: 'Non inviare nulla, inserisco io',
        notificationsTitre: 'Notifiche',
        silenceAide: 'Durante queste ore il telefono resta silenzioso. Nulla va perduto: viene ' +
            'trattenuto e consegnato tutto insieme alla fine del silenzio.',
        silenceActive: 'Lasciarmi in pace la notte',
        silenceDesactive: 'Avvisarmi a qualsiasi ora',
        silenceDebut: 'Dalle',
        silenceFin: 'Fino alle',
        silenceNote: (fin) => `Ciò che arriva durante il silenzio le viene consegnato alle ${fin}, in un solo ` +
            'messaggio. Un avviso urgente passa comunque.',
        silenceNoteInactif: 'Viene avvisato non appena succede qualcosa, a qualsiasi ora.',
        emailTitre: 'E-mail',
        emailAide: 'Questa impostazione riguarda solo la sua casella di posta. Le notifiche sul ' +
            'telefono restano invariate.',
        emailImmediat: 'Un’e-mail ogni volta',
        emailQuotidien: 'Un solo riepilogo al giorno',
        emailImmediatNote: 'Riceve un’e-mail non appena succede qualcosa, tranne durante le sue ore di silenzio.',
        emailQuotidienNote: (heure) => `Una sola e-mail al giorno, alle ${heure}, con il conteggio di quanto è successo. Il ` +
            'telefono continua ad avvisarla subito. Un avviso urgente passa oltre e le viene ' +
            'inviato immediatamente.',
        emailHeure: 'Riepilogo inviato alle',
        conges: 'Vacanze scolastiche',
        congesAide: 'Da dove il calendario prende le date delle vacanze. Il calendario ufficiale copre la ' +
            'Francia metropolitana; un file .ics subentra per i territori d’oltremare, una scuola ' +
            'all’estero o un istituto che fissa date proprie.',
        congesPartage: 'Questa scelta appartiene al fascicolo: l’altro genitore vede lo stesso calendario.',
        congesOfficiel: 'Calendario ufficiale',
        congesOfficielZone: (zone) => `Zona ${zone}, dedotta dal codice postale della scuola.`,
        congesOfficielSansZone: 'Nessuna zona dedotta: indica il codice postale della scuola nella scheda del bambino, ' +
            'oppure carica un file.',
        congesFichier: 'File caricato',
        congesFichierAide: 'Un file .ics esportato dall’agenda della scuola. Viene letto all’arrivo e non è ' +
            'conservato: restano solo le sue date.',
        congesDeposer: 'Scegli un file .ics',
        congesDepotEnCours: 'Lettura del file…',
        congesDepot: (nom, periodes) => `${nom} · ${periodes} periodo${periodes > 1 ? 'i' : ''}`,
        congesCouverture: (debut, fin) => `Dal ${debut} al ${fin}.`,
        congesRetirer: 'Rimuovi questo file',
        congesErreur: 'Impossibile leggere questo file',
        congesAucunDossier: 'Non hai ancora nessun fascicolo da configurare.',
        congesMemes: 'Vacanze dei bambini',
        congesMemesOui: 'Le stesse per tutti',
        congesMemesNon: 'Un’impostazione per bambino',
        congesMemesAide: 'Una scuola media e un liceo ai due lati di un confine di accademia bastano a separare ' +
            'i fratelli. Ogni bambino parte allora dal calendario ufficiale della SUA scuola, e il ' +
            'calendario incornicia i suoi giorni con il suo colore.',
        congesEnfant: (prenom) => `Vacanze di ${prenom}`,
    },
    dates: {
        mois: [
            'gennaio',
            'febbraio',
            'marzo',
            'aprile',
            'maggio',
            'giugno',
            'luglio',
            'agosto',
            'settembre',
            'ottobre',
            'novembre',
            'dicembre',
        ],
        jour: 'Giorno',
        moisLabel: 'Mese',
        annee: 'Anno',
    },
    creerDossier: {
        titre: 'Crea un fascicolo',
        etapeSur4: (etape) => `Passaggio ${etape} di 4`,
        erreurEtape: 'Questo passaggio non è andato a buon fine',
        jalon: { enfants: 'Figli', garde: 'Affido', invitation: 'Invito', pret: 'Pronto' },
        etatJalon: { termine: 'completato', enCours: 'in corso', aVenir: 'da fare' },
        etape1: {
            titreCarte: 'I vostri figli',
            aideFratrie: 'Un fascicolo riunisce i figli che avete con uno stesso altro genitore. Per aggiungere un fratello o una sorella a un fascicolo esistente, apritelo e andate su «Figli».',
            prenom: 'Nome',
            dateNaissance: 'Data di nascita',
            suffixeRang: (index) => ` del figlio/a ${index + 1}`,
            enfantParDefaut: (index) => `Figlio/a ${index + 1}`,
            retirer: 'Rimuovi',
            retirerSuffixe: (index, prenom) => ` il figlio/a ${index + 1}${prenom ? `, ${prenom}` : ''}`,
            ajouter: 'Aggiungi un altro figlio/a',
            continuer: 'Continua',
        },
        etape2: {
            titreCarte: 'Il regime di affido',
            aideModification: "Potrete modificarlo in seguito — ogni modifica richiederà l'accordo dell'altro genitore.",
            schema: 'Regime',
            nidation: 'In nidificazione (nesting)',
            nidationAide: "Il figlio/a resta nell'abitazione familiare e sono i genitori ad alternarsi. La ripartizione del tempo resta quella del regime scelto.",
            dateDebut: 'Data di inizio',
            heure: 'Orario del passaggio',
            heureAide: "Spesso l'uscita da scuola.",
            quiCommence: 'Chi inizia',
            moi: 'Io',
            autreParent: "L'altro genitore",
            revenir: 'Indietro',
            creer: 'Crea il fascicolo',
            creationEnCours: 'Creazione in corso…',
        },
        etape3: {
            titreCarte: "Invita l'altro genitore",
            intro: "Repère tutela entrambi i genitori allo stesso modo: l'altro genitore avrà esattamente gli stessi diritti su questo fascicolo, e nessuno dei due potrà toglierli nulla.",
            redaction: 'Il messaggio è redatto da Repère, con un tono neutro. Non dovete scrivere nulla.',
            email: "Indirizzo e-mail dell'altro genitore",
            plusTard: 'Più tardi',
            envoyer: "Invia l'invito",
            envoiEnCours: 'Invio in corso…',
        },
        etape4: {
            titreCarte: 'Il vostro fascicolo è pronto',
            messageAvecInvitation: "L'invito è stato inviato. Il fascicolo è già utilizzabile, senza attendere una risposta.",
            messageSansInvitation: 'Il fascicolo è già utilizzabile. Potrete invitare l’altro genitore quando vorrete.',
            ouvrir: 'Apri il fascicolo',
        },
        residence: {
            pays: 'Paese di residenza del figlio/a',
            ville: 'Città di residenza del figlio/a',
            zone: (zone) => `Zona delle vacanze scolastiche ${zone}.`,
            zoneInconnue: "Zona non riconosciuta — l'ortografia esatta del comune aiuta a trovarla.",
        },
    },
    entree: {
        presentation: {
            accrocheCourte: 'Il calendario di affido, i messaggi e i documenti dei vostri figli, tutti in un unico posto.',
            accrocheLongue: 'Repère è lo strumento dei genitori separati: il calendario di affido, i messaggi e i documenti dei vostri figli, tutti in un unico posto.',
            publics: 'È pensato per entrambi i genitori, qualunque sia il regime di affido e qualunque sia lo stato della vostra relazione. Un avvocato, un mediatore o un assistente sociale può essere invitato in sola lettura, se uno di voi lo decide.',
            garanties: "Tutto viene datato dai nostri server, e nulla può più essere modificato o eliminato — né da voi, né dall'altro genitore, né dal nostro team. Ciascuno dispone esattamente degli stessi diritti e vede esattamente le stesse cose.",
        },
        modesAcces: {
            titre: 'Avete ricevuto un invito?',
            autreParentTitre: "Siete l'altro genitore",
            autreParentTexte: "Unirsi al fascicolo è gratuito: la registrazione e il calendario non richiedono alcun abbonamento. Ciascuno può poi sottoscrivere il proprio se lo desidera — 9,90 € al mese — e nessuno dei due può togliere l'accesso all'altro.",
            proTitre: 'Siete avvocato, mediatore o assistente sociale',
            proTexte: "Il vostro account è gratuito, senza limiti di fascicoli. Accedete in sola lettura a ciò che un genitore vi condivide, per la durata che decide. L'altro genitore viene informato del vostro arrivo: nessuno entra in un fascicolo a insaputa di qualcuno.",
        },
        fournisseurs: {
            indisponible: 'Prossimamente',
            separateurOu: 'oppure',
            intro: 'Con un account che avete già — senza una nuova password da ricordare.',
            redirection: (nom) => `Reindirizzamento verso ${nom}…`,
            verbeAvec: (verbe, nom) => `${verbe} con ${nom}`,
            indisponibleDetail: "Prossimamente. L'indirizzo e-mail e la password danno accesso a tutto il prodotto: nessuna funzione dipenderà mai da un account di terzi.",
        },
        feuille: {
            fermer: 'Chiudi',
        },
        connexion: {
            titre: 'Accedi',
            verbe: 'Accedi',
            pasDeCompte: 'Non avete ancora un account?',
            sInscrire: 'Registrati',
            email: 'Indirizzo e-mail',
            motDePasse: 'Password',
            motDePasseOublie: 'Password dimenticata?',
            connexionEnCours: 'Accesso in corso…',
            erreurTitre: 'Accesso non riuscito',
            echecRefus: "L'accesso è stato interrotto. Potete riprovare, oppure inserire il vostro indirizzo e la vostra password.",
            echecExpire: "L'accesso ha impiegato troppo tempo. Riprovate.",
            echecGenerique: "L'accesso con questo provider non è andato a buon fine. Potete inserire il vostro indirizzo e la vostra password.",
        },
        inscription: {
            titre: 'Crea un account',
            verbe: 'Registrati',
            motDePasseTropCourt: 'La password deve contenere almeno 12 caratteri.',
            verifiezBoite: 'Controllate la vostra casella di posta',
            siAdresseUtilisable: 'Se questo indirizzo può essere utilizzato, un messaggio è appena stato inviato. Aprite il link che contiene per confermare il vostro indirizzo.',
            dejaConnexionPossible: 'Potete già accedere: la conferma può attendere.',
            dejaCompte: 'Avete già un account?',
            seConnecter: 'Accedi',
            prenom: 'Nome',
            prenomAide: "Mostrato all'altro genitore.",
            email: 'Indirizzo e-mail',
            motDePasse: 'Password',
            motDePasseAide: 'Almeno 12 caratteri. Una frase che ricordate fa una buona password.',
            erreurTitre: "Impossibile creare l'account",
            creationEnCours: 'Creazione in corso…',
            creerMonCompte: 'Crea il mio account',
            echecGenerique: 'Qualcosa non ha funzionato. Riprovate tra un istante.',
        },
    },
    dossier: {
        categories: {
            aujourdhui: 'Oggi',
            calendrier: 'Calendario',
            messages: 'Messaggi',
            depenses: 'Spese',
            journal: 'Diario',
            enfants: 'Figli',
        },
        navigation: {
            ariaCategories: 'Categorie del fascicolo',
            reserveParent: 'Riservato ai piani Solo e Duo. Ciò che è già registrato resta leggibile.',
            reserveParentSuffixe: ', riservato ai piani Solo e Duo',
            nouveaute: (n) => accorder('it', n, { one: '1 novità', other: `${n} novità` }),
        },
        calendrier: {
            moisPrecedent: 'Mese precedente',
            moisSuivant: 'Mese successivo',
            erreurChargement: 'Il calendario non è stato caricato',
            titre: (moisEtAnnee) => `Calendario di affido — ${moisEtAnnee}`,
            chezVous: 'Da voi',
            chezAutre: (nom) => `Da ${nom}`,
            nonDefini: 'non definito',
            libelleEchange: 'scambio di giorni',
            libelleDerogation: 'eccezione concordata',
            titreEchange: 'Scambio di giorni concordato',
            titreDerogationConvenue: 'Eccezione concordata',
            avecMotif: (base, motif) => `${base} — ${motif}`,
            suffixeDerogation: (libelle) => `, ${libelle}`,
            suffixeMotif: (motif) => `, motivo: ${motif}`,
            marqueEchange: 'Scambiato',
            legendeEchange: 'Giorno scambiato di comune accordo',
            suffixeConge: ' — vacanze scolastiche',
            suffixeCongeEnfants: (prenoms) => ` — vacanze scolastiche: ${prenoms}`,
            legendeConge: (zone) => `Vacanze scolastiche · zona ${zone}`,
            legendeCongeFichier: 'Vacanze scolastiche · file caricato',
            legendeCongeEnfant: (prenom, source) => `${prenom} — ${source}`,
            legendeCongesAbsents: 'Vacanze scolastiche: niente da mostrare. Indica il codice postale della scuola nella ' +
                'scheda del bambino, oppure carica un file delle vacanze da Il mio account › Opzioni.',
        },
        journal: {
            ariaFiltrer: 'Filtra il diario',
            filtreTout: 'Tutte',
            filtrePartagees: 'Condivise',
            filtrePrivees: 'Private',
            entreeSuffixe: (n) => accorder('it', n, { one: ', 1 voce', other: `, ${n} voci` }),
            erreurChargement: 'Il diario non è stato caricato',
            modeSoloTexte: 'Per ora siete soli su questo fascicolo, e il diario funziona normalmente. Se l’altro genitore si unirà in seguito, vedrà le voci che avete contrassegnato come condivise, con la loro data originale.',
            videTout: 'Nessuna voce per ora.',
            videPartagees: 'Nessuna voce condivisa.',
            videPrivees: 'Nessuna voce privata.',
            auteurVous: 'Voi',
            auteurAutreParent: "L'altro genitore",
            marquePrivee: 'Privata',
            marquePartagee: 'Condivisa',
            invisibleSuffixePrivee: 'Voce privata, visibile solo a voi, inalterabile.',
            invisibleSuffixePartagee: "Voce condivisa con l'altro genitore, inalterabile.",
            mentionImmuable: 'Ogni voce viene datata dai nostri server e non può più essere modificata né eliminata — né da voi, né dall’altro genitore, né dal nostro team. Annotate fatti: cosa è successo, quando.',
            mentionImmuableBouton: 'Immutabilità del diario',
            labelFait: 'Il fatto da annotare',
            placeholderFait: 'Il fatto da annotare — «Cambio avvenuto alle 18:05»',
            ariaQuiPeutVoir: 'Chi può vedere questa voce?',
            intituleVisiblePar: 'Visibile per',
            visibiliteAutre: "L'altro genitore",
            visibiliteAutreAide: 'Compare in modo identico nel diario di entrambi i genitori.',
            visibiliteMoi: 'Solo voi',
            visibiliteMoiAide: "L'altro genitore non ne viene informato. Comparirà solo nella vostra esportazione.",
            aideChoixDefaut: 'Scegliete chi vedrà questa voce: nulla è preselezionato.',
            enregistrementEnCours: 'Salvataggio…',
            consigner: 'Annota',
            erreurEnregistrement: 'La voce non è stata salvata',
            reformuler: 'Riformula questo testo per me',
            reformulationEnCours: 'Riformulazione…',
            reformulationTitre: 'Un altro modo di dirlo',
            reformulationAide: 'Non viene conservato nulla: né la vostra bozza, né questa proposta — nessuno ' +
                'saprà che l’avete chiesta.',
            reformulationUtiliser: 'Usare questa versione',
            reformulationGarder: 'Tenere il mio testo',
            reformulationDejaNeutre: 'Il vostro testo è già fattuale: non c’è nulla da addolcire.',
            reformulationIndisponible: 'La riformulazione non è disponibile al momento. Potete annotare il testo così com’è.',
            reformulationBudget: 'Avete usato le riformulazioni di oggi. Tornano domani.',
            reformulationTropLong: 'Questo testo è troppo lungo per essere riformulato.',
        },
        depenses: {
            statutAttente: 'In attesa di risposta',
            statutAcceptee: 'Accettata',
            statutContestee: 'Contestata',
            statutRemboursee: 'Rimborsata',
            categories: ['salute', 'scuola', 'mensa', 'attività', 'abbigliamento', 'trasporto'],
            comptesAJour: 'I conti sono aggiornati.',
            soldePhrase: (debiteur, jeSuisDebiteur, montant, crediteur) => `${debiteur} ${jeSuisDebiteur ? 'dovete' : 'deve'} ${montant} a ${crediteur}.`,
            detailLigneALigne: 'Il dettaglio, riga per riga',
            ligneDetail: (date, categorie, montant, payeur, montantAutre) => `${date} — ${categorie}: ${montant} anticipati da ${payeur}, di cui ${montantAutre} a carico dell'altro.`,
            soldeNonStocke: 'Questo saldo non viene memorizzato da nessuna parte: viene ricalcolato a ogni visualizzazione a partire da queste righe. Potete rifare voi stessi il conto.',
            sansRegleTitre: 'Alcune spese sono in attesa di una chiave di ripartizione',
            sansRegleTexte: (n) => accorder('it', n, {
                one: '1 spesa è antecedente a qualsiasi chiave e non viene conteggiata.',
                other: `${n} spese sono antecedenti a qualsiasi chiave e non vengono conteggiate.`,
            }),
            erreurChargement: 'Le spese non sono state caricate',
            declarerUneDepense: 'Dichiara una spesa',
            justificatifAnalyse: 'Analizzato, cifrato e allegato ai documenti del fascicolo.',
            lectureTitre: 'Leggere il giustificativo al posto vostro?',
            lectureQuestion: 'Repère può leggere la foto del vostro scontrino e proporvi importo, data e ' +
                'categoria. Voi rileggete, correggete e confermate.',
            lectureDetail: 'La foto è inviata a Mistral, il nostro fornitore europeo di IA, solo a questo ' +
                'scopo. Non vi è conservata, e noi non ne conserviamo nulla. È l’unico dato del ' +
                'vostro fascicolo che esce dai nostri server: potete revocare questo consenso in ' +
                'qualsiasi momento in «Opzioni».',
            lectureAccepter: 'Sì, leggete i miei giustificativi',
            lectureRefuser: 'No, inserisco io',
            lectureEnCours: 'Lettura del giustificativo…',
            lectureProposee: 'Importo, data, categoria e commento proposti dal giustificativo. Rileggeteli.',
            commentaire: 'Commento',
            commentairePlaceholder: 'Farmacia del Centro — antibiotici e cerotti',
            commentaireAide: 'Facoltativo. Ciò che dice lo scontrino: il negozio, ciò che è stato acquistato. La ' +
                'lettura del giustificativo può proporlo; voi lo rileggete.',
            lectureRien: 'Non è stato possibile leggere nulla da questa foto. Inserite la spesa a mano.',
            lectureIndisponible: 'La lettura non è disponibile al momento. Inserite la spesa a mano.',
            lectureBudget: 'Avete usato le letture di oggi. Tornano domani.',
            lectureQuota: 'Questo fascicolo ha usato le sue cinque letture di oggi. Tornano domani.',
            retirer: 'Rimuovi',
            photographierLeTicket: 'Fotografa lo scontrino',
            choisirUnFichier: 'Scegli un file',
            envoiEnCours: 'Invio in corso…',
            justificatifAide: 'Facoltativo, ma è ciò che decide in caso di contestazione della spesa. PDF o foto.',
            erreurJustificatif: 'Il giustificativo non è stato allegato',
            montant: 'Importo',
            montantInvalide: 'Importo non valido.',
            dateDeLaDepense: 'Data della spesa',
            ariaCategorie: 'Categoria della spesa',
            erreurDeclaration: 'La spesa non è stata salvata',
            enregistrementEnCours: 'Salvataggio…',
            declarerLaDepense: 'Dichiara la spesa',
            aideAvecCategorie: 'La data scelta determina la chiave di ripartizione applicata.',
            aideSansCategorie: 'Scegliete una categoria: nulla è preimpostato.',
            unParent: 'Un genitore',
            vous: 'Voi',
            justificatifJoint: 'Giustificativo allegato',
            avancePar: (date, payeur) => `${date} · anticipato da ${payeur}`,
            accepter: 'Accetta',
            motifSiConteste: 'Motivo, se contestate',
            motifAide: 'Un disaccordo senza motivo non porta a nulla: dite qual è il problema.',
            contester: 'Contesta',
            videListe: 'Nessuna spesa per ora.',
            ongletDetail: 'Dettaglio',
            ongletPartagees: 'Spese condivise',
        },
        messagerie: {
            ariaFils: 'Argomenti di conversazione',
            filTous: 'Tutti',
            filSansFil: 'Senza argomento',
            filSante: 'Salute',
            filEcole: 'Scuola',
            filVacances: 'Vacanze',
            filUrgences: 'Emergenze',
            messageSuffixe: (n) => accorder('it', n, { one: ', 1 messaggio', other: `, ${n} messaggi` }),
            erreurChargement: 'I messaggi non sono stati caricati',
            ouvrirLaPieceJointe: "Apri l'allegato",
            erreurOuverturePiece: 'Non è stato possibile aprire l’allegato',
            pieceJointeScellee: 'Sigillato con il messaggio: sostituirlo ne romperebbe l’impronta.',
            redactionPieceScellee: (nomFichier) => `${nomFichier} — analizzato, cifrato, e la sua impronta sigillata con il messaggio: sostituirlo in seguito romperebbe la catena.`,
            videAucun: 'Nessun messaggio per ora.',
            videAucunDansCeFil: 'Nessun messaggio in questo argomento.',
            nouveauxMessages: (n) => accorder('it', n, { one: '1 nuovo messaggio', other: `${n} nuovi messaggi` }),
            vosEnvoisDifferes: 'I vostri invii programmati',
            envoisDifferesAide: 'Visibili solo a voi finché non vengono inviati. Potete ancora annullarli.',
            envoiPrevu: (corps, date, heureTexte) => `«${corps}» — invio previsto il ${date} alle ${heureTexte}`,
            annulerCetEnvoi: 'Annulla questo invio',
            retirer: 'Rimuovi',
            mentionImmuable: 'I messaggi scambiati qui non possono essere né modificati né eliminati — né da voi, né dall’altro genitore, né dal nostro team. Ognuno viene datato dai nostri server.',
            mentionImmuableBouton: 'Immutabilità dei messaggi',
            reformuler: 'Riformula questo messaggio per me',
            reformulationEnCours: 'Riformulazione…',
            reformulationTitre: 'Un altro modo di dirlo',
            reformulationAide: 'Non è stato inviato nulla e non viene conservato nulla: né la vostra bozza, né ' +
                'questa proposta. L’altro genitore non saprà che l’avete chiesta.',
            reformulationUtiliser: 'Usare questa versione',
            reformulationGarder: 'Tenere il mio testo',
            reformulationDejaNeutre: 'Il vostro messaggio è già fattuale: non c’è nulla da addolcire.',
            reformulationIndisponible: 'La riformulazione non è disponibile al momento. Il messaggio parte invariato.',
            reformulationBudget: 'Avete usato le riformulazioni di oggi. Tornano domani.',
            reformulationTropLong: 'Questo messaggio è troppo lungo per essere riformulato.',
            votreMessage: 'Il vostro messaggio',
            placeholderEcrire: 'Scrivi un messaggio…',
            joindreUnDocument: 'Allega un documento',
            envoyerPlusTard: 'Invia più tardi',
            envoiEnCours: 'Invio in corso…',
            programmerLEnvoi: "Programma l'invio",
            envoyer: 'Invia',
            dateEtHeureEnvoi: 'Data e ora di invio',
            aideHorodatage: 'Farà fede la marca temporale dell’invio effettivo.',
            erreurEnvoi: 'Il messaggio non è stato inviato',
            inactiveTexte: "La messaggistica si attiverà quando l'altro genitore avrà aderito al fascicolo: non ha senso senza un interlocutore.",
            auteurVous: 'Voi',
            auteurAutreParent: "L'altro genitore",
            messageInvisible: (date, heureTexte, numero) => `${date} alle ${heureTexte}. Messaggio numero ${numero}, inalterabile.`,
        },
        suppression: {
            ouvrir: 'Eliminare questo fascicolo',
            titre: 'Eliminare questo fascicolo',
            texte: "L'eliminazione si decide in due: l'altro genitore riceverà un messaggio e dovrà " +
                'confermarla. Una volta confermata, il fascicolo resta consultabile per trenta ' +
                'giorni senza poter essere modificato, poi viene distrutto definitivamente. In quel ' +
                "periodo, l'uno come l'altro può annullare tutto.",
            texteSolo: 'Siete soli su questo fascicolo: il messaggio di conferma sarà inviato a voi. Una ' +
                "volta confermata, l'eliminazione lascia il fascicolo consultabile per trenta " +
                'giorni senza poter essere modificato, poi viene distrutto definitivamente. Potete ' +
                "annullare tutto fino all'ultimo giorno.",
            demander: "Chiedere l'eliminazione",
            envoiEnCours: 'Invio in corso…',
            erreur: 'Non è stato possibile inviare la richiesta',
            renoncer: 'Non eliminare',
            attenteAutre: "È stata chiesta l'eliminazione di questo fascicolo. L'altro genitore ha ricevuto " +
                'un messaggio: avrà effetto solo se la conferma.',
            attenteVous: "È stata chiesta l'eliminazione di questo fascicolo. Avete ricevuto un messaggio: " +
                'apritelo per confermarla o rifiutarla.',
            attenteEcheance: (date) => `Senza risposta, questa richiesta si annullerà da sé il ${date}.`,
            archiveTitre: 'Fascicolo archiviato',
            archiveTexte: (date) => `Questo fascicolo sarà distrutto definitivamente il ${date}.`,
            archiveLecture: 'Fino ad allora resta consultabile — potete rileggerlo e chiederne una copia — ma ' +
                'nessuno può più scrivervi.',
            annuler: "Annullare l'eliminazione",
            annulationEnCours: 'Annullamento…',
        },
        ecran: {
            modeSolo: `State utilizzando questo fascicolo da soli`,
            modePartage: `Fascicolo condiviso · diritti identici`,
            modePartageAvec: (prenom) => `Condiviso con ${prenom} · diritti identici`,
            quiALEnfant: `Chi ha il figlio/a?`,
            quiReponseVous: `Il figlio/a è da voi`,
            quiReponseAutre: (prenom) => `Il figlio/a è da ${prenom}`,
            quiAucunSchema: `Nessun regime di affido copre questa data`,
            quiDerogation: `Per deroga concordata.`,
            quiRecherche: `Ricerca in corso…`,
            quiErreur: `Non è stato possibile ottenere la risposta`,
            quiDateAujourdhui: (date) => `Oggi, ${date}`,
            quiQuelleDate: `Quale data?`,
            quiAutreJour: `Vedere un altro giorno`,
            quiRevenirAujourdhui: `Tornare a oggi`,
            demandesAccord: `Richieste di accordo`,
            ongletNouveautes: `Novità`,
            ongletDossier: `Il fascicolo`,
            modeSoloTexte: `Il calendario, il diario e i documenti funzionano normalmente. Tutto ciò che registrate da ora viene datato.`,
            invitationEnvoyeeTexte: `È stato inviato un invito. Resta valido per 30 giorni.`,
            renvoyerOuCorriger: `Rinvia o correggi l'indirizzo`,
            nouvelleAdresseRemplace: `Il nuovo indirizzo sostituisce il precedente: il link già inviato non è più valido.`,
            peutInviterQuandVeut: `Potete invitare l'altro genitore quando volete.`,
            erreurInvitation: `Non è stato possibile inviare l’invito`,
            emailAutreParent: `Indirizzo e-mail dell'altro genitore`,
            aideInvitation: `Il messaggio è redatto da Repère, con un tono neutro.`,
            envoiEnCours: `Invio in corso…`,
            envoyerInvitation: `Invia l'invito`,
            calendrierDeGarde: `Il calendario di affido`,
            demanderEchange: `Richiedi uno scambio di giorni`,
            historiqueSchema: `Cronologia del regime di affido`,
            depensesPartagees: `Spese condivise`,
            ficheDe: (prenom) => `Scheda di ${prenom}`,
        },
    },
    schemasDeGarde: {
        schemas: {
            alternating_week: {
                libelle: 'Settimana alternata (7/7)',
                detail: 'Una settimana con uno, una settimana con l’altro. Il regime più diffuso.',
            },
            two_two_five_five: {
                libelle: '2-2-5-5',
                detail: 'Due giorni fissi con ciascuno ogni settimana, poi cinque giorni compreso il fine settimana.',
            },
            two_two_three: {
                libelle: '2-2-3',
                detail: 'Due notti, due notti, tre notti: pensato per i bambini più piccoli.',
            },
            three_four_four_three: {
                libelle: '3-4-4-3',
                detail: 'Cambio a metà settimana, su un ciclo di due settimane.',
            },
            fortnight: {
                libelle: 'Quindicina alternata (14/14)',
                detail: 'Due settimane con ciascuno: adolescenti, o distanza geografica.',
            },
            nine_five: {
                libelle: 'Alternanza 9/5',
                detail: 'Nove notti con uno, cinque con l’altro, su un ciclo di due settimane.',
            },
            ten_four: {
                libelle: 'Alternanza 10/4',
                detail: 'Dieci notti con uno, quattro con l’altro, su un ciclo di due settimane.',
            },
            alternate_weekends: {
                libelle: 'Fine settimana alterni (1°, 3°, 5°)',
                detail: 'Diritto di visita e pernottamento classico: un fine settimana su due, da venerdì a domenica.',
            },
            extended_weekends: {
                libelle: 'Fine settimana alterni estesi',
                detail: 'Diritto di visita esteso: un fine settimana su due, dal venerdì sera al lunedì mattina.',
            },
            visits_only: {
                libelle: 'Visite senza pernottamento',
                detail: 'Diritto di visita ridotto: solo di giorno, senza pernottamento. Ogni visita viene inserita nel calendario.',
            },
            holidays_only: {
                libelle: 'Solo vacanze scolastiche',
                detail: 'Diritto di visita a lunga distanza: niente fine settimana regolari, la maggior parte delle vacanze.',
            },
            third_party: {
                libelle: 'Residenza presso un terzo',
                detail: 'Il figlio/a risiede presso un terzo; i tempi di ciascun genitore sono stabiliti singolarmente.',
            },
            custom: {
                libelle: 'Su misura',
                detail: 'Nessuna generazione automatica: il calendario si costruisce periodo per periodo.',
            },
        },
        familles: {
            alternance: 'Affido alternato',
            alternance_inegale: 'Affido alternato non paritario',
            residence_principale: 'Residenza principale presso un genitore',
            autre: 'Altro',
        },
    },
    apercu: {
        titre: "Anteprima dell'alternanza",
        pasDeCycle: (libelle) => `«${libelle}» non ha un ciclo da svolgere: i tempi di ciascuno vengono stabiliti periodo per periodo, nel calendario del fascicolo. Non c'è quindi nulla da vedere in anteprima qui.`,
        choisirDate: "Scegliete una data di inizio: l'anteprima mostrerà quindi i primi tre mesi, giorno per giorno.",
        aPartirDu: (date) => `A partire dal ${date}:`,
        joursChezVous: (n) => accorder('it', n, { one: '1 giorno da voi', other: `${n} giorni da voi` }),
        etJoursChezAutre: (n) => `e ${n} dall'altro genitore, sui tre mesi mostrati.`,
        chezVousInvisible: ', da voi',
        chezAutreInvisible: ", dall'altro genitore",
        legendeChezVous: 'Da voi',
        legendeChezAutre: "Dall'altro genitore",
        legendePassage: 'Passaggio',
    },
    site: {
        nav: {
            accueil: 'Home',
            tarifs: 'Prezzi',
            connexion: 'Accedi',
            inscription: 'Registrati',
        },
        footer: {
            accroche: 'Organizzazione e serenità per i genitori separati. Ospitato in Francia, nessun tracciante, nessun cookie di terze parti.',
            produit: 'Prodotto',
            tarifsLien: 'Prezzi',
            applicationsLien: 'App mobili',
            legal: 'Legale',
            mentionsLegales: 'Note legali',
            confidentialite: 'Informativa sulla privacy',
            pied: (annee) => `Repère-kids — ${annee}. Ospitato in Francia.`,
            version: (version, horodatage) => `Versione ${version} — build del ${horodatage}`,
        },
        accueil: {
            titre: 'Coordinazione per genitori separati',
            description: "Repère: calendario d'affido, spese condivise, messaggistica con marca temporale e cronologia inalterabile per genitori separati.",
            badgeConfiance: 'Ospitato in Francia · Nessun tracciante',
            h1: 'La coordinazione, senza che ogni scambio diventi una trattativa.',
            accroche: "Un calendario d'affido, spese condivise, documenti, scambi — e una traccia con marca temporale che nessuno dei due genitori può riscrivere.",
            etrePrevenu: 'Ricevi un avviso al lancio',
            pointChiffre: 'Cifrato per fascicolo',
            pointServeurs: 'Server in Francia',
            pointHistorique: 'Cronologia inalterabile',
            question: 'Chi ha i bambini mercoledì?',
            reponseForte: 'Mercoledì 16 settembre — da voi',
            reponseSuite: 'Prossimo passaggio: venerdì 18, ore 16:30',
            moisCarte: 'Settembre 2026',
            legendeChezVous: 'Da voi',
            legendeChezAutre: "Dall'altro genitore",
            captureAlt: 'Schermata di Repère-kids: il calendario di affidamento di un fascicolo condiviso, agosto 2026.',
            captureLegende: "L'applicazione, vista calendario. Dati fittizi.",
            surTitreChange: 'Cosa cambia con Repère',
            titreChange: 'Tre domande che non serve più discutere',
            introChange: 'Il calendario, gli accordi e la cronologia — ciascuno deciso una volta per tutte dal prodotto, non da voi.',
            carte1Titre: 'Un calendario che risponde subito',
            carte1Texte: 'Chi ha il bambino mercoledì? La risposta è sullo schermo, per oggi come per qualsiasi altra data.',
            carte2Titre: 'Accordi datati',
            carte2Texte: 'Uno scambio di giorni si propone, si accetta o si rifiuta. Ogni passaggio viene registrato, nessuno deve ricordare chi ha detto cosa.',
            carte3Titre: 'Una cronologia che non appartiene a nessuno',
            carte3Texte: 'Né voi, né l’altro genitore, né il nostro supporto possono modificare o eliminare ciò che è stato condiviso.',
            surTitreParti: 'Approccio',
            titreParti: 'Progettato per non diventare mai un’arma',
            texteParti: 'Repère registra fatti; non li interpreta e non li mette in scena. I due genitori hanno esattamente gli stessi diritti — nessuno dei due può escludere l’altro, né rimuovere alcunché dalla cronologia comune.',
            absencesIntitule: 'Cosa non troverete qui',
            absence1: 'Conferma di lettura',
            absence2: 'Stato «online», «visto alle», «ultima connessione»',
            absence3: 'Contatore di ritardi, punteggio di comportamento',
            absence4: 'Account «proprietario» del fascicolo',
            surTitreAcces: 'Modalità di accesso',
            titreAcces: 'Avete ricevuto un invito?',
            introAcces: 'La domanda si pone prima di creare un account, quindi la risposta arriva prima del modulo.',
            acces1Titre: "Siete l'altro genitore",
            acces1Texte: "Unirsi al fascicolo è gratuito: la registrazione e il calendario non richiedono alcun abbonamento. Ognuno può poi sottoscrivere il proprio se lo desidera — 9,90 € al mese — e nessuno può togliere l'accesso all'altro.",
            acces1Badge: 'Gratuito',
            acces2Titre: 'Siete avvocato, mediatore o assistente sociale',
            acces2Texte: "Il vostro account è gratuito, senza limiti di fascicoli. Accedete in sola lettura a ciò che un genitore vi apre, per la durata che decide. L'altro genitore viene informato del vostro accesso: nessuno entra in un fascicolo all'insaputa di qualcuno.",
            acces2Badge: 'Gratuito, illimitato',
            acces3Titre: 'State scoprendo il servizio senza aver ricevuto nulla',
            acces3Texte: "Iscrivetevi alla lista d'attesa per ricevere un avviso all'apertura. Create un fascicolo solo se decidete di invitare l'altro genitore.",
            acces3Badge: 'Senza account',
            surTitreTarifs: 'Prezzi',
            titreTarifs: 'Un abbonamento per genitore. Nient’altro.',
            introTarifs: 'Nessuna versione «premium» che sblocchi diritti sull’altro: i due genitori vedono la stessa cosa, qualunque sia il loro abbonamento.',
            basculeLegende: 'Frequenza di fatturazione',
            basculeMensuel: 'Mensile',
            basculeAnnuel: 'Annuale',
            tarifRejoindreTitre: 'Link',
            tarifRejoindrePrix: '0 €',
            tarifRejoindreTexte: 'Per il genitore invitato a unirsi a un fascicolo esistente.',
            tarifRejoindreAvantage1: "Calendario d'affido condiviso",
            tarifRejoindreAvantage2: 'Lettura completa della cronologia',
            tarifRejoindreAvantage3: 'Nessuna scadenza',
            tarifParentTitre: 'Solo',
            tarifParentEtiquette: 'Il più diffuso',
            tarifParentPrixMensuel: '9,90 € / mese, per genitore',
            tarifParentPrixMensuelDuo: '14,90 € / mese, per entrambi i genitori',
            tarifParentPrixAnnuelSeul: '99 € / anno, per genitore',
            tarifParentPrixAnnuelDuo: '149 € / anno, per entrambi i genitori',
            tarifParentPrixAnnuel: 'Due mesi in omaggio rispetto al mensile.',
            tarifParentEssaiGratuit: 'Prova gratuita di 7 giorni',
            tarifParentBoutonNotification: 'Prenota il mio accesso Early bird',
            tarifParentSwitchDuo: "Includere l'altro genitore",
            tarifParentEarlybirdEtiquette: 'Early bird',
            tarifParentEarlybirdTexte: '79 € il primo anno per gli iscritti alla lista d’attesa, poi tariffa annuale.',
            tarifParentEarlybirdTexteDuo: '129 € il primo anno per gli iscritti alla lista d’attesa, poi tariffa annuale.',
            tarifParentEngagement: 'Senza vincoli mensili. Annullabile con un clic dal vostro account.',
            tarifParentOptionDeuxEtiquette: 'Duo',
            tarifParentOptionDeuxTexte: "+5 € al mese, 14,90 € in totale, per coprire anche l'abbonamento dell'altro genitore.",
            tarifParentOptionDeuxTexteAnnuel: "+50 € all'anno, 149 € in totale, per coprire anche l'abbonamento dell'altro genitore.",
            tarifParentAvantage1: 'Tutto ciò che include Link',
            tarifParentAvantage2: 'Messaggistica, spese condivise, documenti cifrati',
            tarifParentAvantage3: 'Proposte di scambio e diario',
            tarifParentAvantage4: 'Esportazione con marca temporale del fascicolo',
            tarifParentAvantage5: 'Invito di un professionista in sola lettura',
            tarifProTitre: 'Pro',
            tarifProPrix: '0 €',
            tarifProTexte: 'Avvocato, mediatore familiare, assistente sociale.',
            tarifProAvantage1: 'Numero illimitato di fascicoli',
            tarifProAvantage2: 'Accesso in lettura, su invito di un genitore',
            tarifProAvantage3: 'Esportazione della cronologia autenticata',
            mentionTarifs: 'Prezzi IVA inclusa. Il servizio non è ancora aperto: le condizioni precise — durata di prova, modalità di disdetta — saranno pubblicate qui all’apertura.',
            surTitreMobile: 'Sul telefono',
            titreMobile: 'Il calendario in tasca, la cronologia nello stesso posto',
            texteMobile: "Le app iOS e Android danno accesso allo stesso fascicolo del web: stessi diritti, stessi dati, stessa cronologia. Una notifica vi avvisa di una proposta di scambio o di un allarme urgente — mai del fatto che l'altro genitore sia connesso.",
            appStore: 'App Store',
            googlePlay: 'Google Play',
            mobileNote: 'I link ad App Store e Google Play saranno attivati all’apertura del servizio.',
            mobileCalendrierAlt: "Anteprima della schermata calendario dell'app mobile.",
            mobileDossiersAlt: "Anteprima della schermata iniziale dell'app mobile: l'elenco dei fascicoli.",
            mobileLegende: "Anteprime dell'app mobile. Dati fittizi.",
        },
        waitlist: {
            titre: 'Ricevi un avviso al lancio',
            texte: 'Lasciate il vostro indirizzo: riceverete un messaggio all’apertura, e nient’altro. Nessuna newsletter, nessun sollecito.',
            labelEmail: 'Indirizzo e-mail',
            bouton: 'Iscrivimi',
            aide: 'Usato solo per avvisarvi al lancio. Cancellabile in qualsiasi momento.',
            erreurEmailInvalide: 'Inserite un indirizzo e-mail valido.',
            envoiEnCours: 'Invio in corso…',
            succes: 'Fatto. Riceverete un messaggio al lancio.',
            echec: 'L’iscrizione non è andata a buon fine. Riprovate tra qualche istante.',
        },
        confidentialite: {
            titre: 'Informativa sulla privacy',
            description: 'Come Repère tratta i dati personali: hosting in Francia, cifratura, assenza di traccianti.',
            avisProvisoire: 'Documento provvisorio, in attesa di convalida legale. Descrive fedelmente il funzionamento tecnico del servizio, ma la sua redazione giuridica deve essere rivista da un legale prima dell’apertura (vedi la roadmap del progetto).',
            miseAJour: (date) => `Ultimo aggiornamento: ${date}.`,
            siteTitre: 'Questo sito',
            siteTexte1: 'Il sito non deposita alcun cookie e non chiama alcun servizio di terze parti.',
            siteTexte2: 'Se vi iscrivete alla lista d’attesa, viene conservato solo il vostro indirizzo e-mail, insieme alla pagina da cui proviene l’iscrizione. Serve unicamente ad avvisarvi al lancio, e potete chiederne la cancellazione in qualsiasi momento.',
            serviceTitre: 'Il servizio',
            serviceHebergementTitre: 'Hosting in Francia',
            serviceHebergementTexte: ', backup compresi. Nessun trasferimento fuori dall’Unione europea.',
            serviceChiffrementTitre: 'Cifratura',
            serviceChiffrementTexte: ': gli scambi sono cifrati in transito; i contenuti sensibili e i documenti sono cifrati a riposo, con una chiave propria per ogni fascicolo di coparentalità.',
            serviceBoutTitre: 'Nessuna cifratura end-to-end',
            serviceBoutTexte: ', e lo diciamo chiaramente: il servizio deve poter apporre una marca temporale, sigillare ed esportare la cronologia per mantenere la sua promessa. I vostri contenuti sono decifrabili dal servizio, mai da terzi.',
            serviceHistoriqueTitre: 'Cronologia comune conservata',
            serviceHistoriqueTexte: ': l’eliminazione di un account rende anonimo il suo titolare ma non distrugge la cronologia condivisa, che appartiene anche all’altro genitore. È una caratteristica essenziale del servizio, indicata fin dalla registrazione.',
            serviceSignatureTitre: 'Prova indipendente',
            serviceSignatureTexte: ': ogni voce viene firmata digitalmente nel momento in cui viene registrata, da un ente indipendente, esterno a Repère — lo stesso procedimento usato per autenticare un documento ufficiale. La prova che nulla è stato modificato da allora resta verificabile in qualsiasi momento.',
            servicePubTitre: 'Nessuna pubblicità, nessun tracciante, nessuna rivendita.',
            servicePubTexte: ' I log tecnici non contengono dati personali.',
            droitsTitre: 'I vostri diritti',
            droitsTexte: 'Accesso, rettifica, portabilità, cancellazione, limitazione e opposizione si esercitano presso il servizio. L’esportazione del fascicolo funge anche da risposta al diritto di accesso. I recapiti del responsabile della protezione dei dati saranno pubblicati qui prima dell’apertura del servizio.',
        },
        mentionsLegales: {
            titre: 'Note legali',
            description: 'Note legali del sito Repère: editore, hosting e proprietà intellettuale.',
            avisProvisoire: 'Documento provvisorio, in attesa di convalida legale. Gli elementi identificativi dell’editore e dell’hosting saranno completati prima dell’apertura del servizio.',
            miseAJour: (date) => `Ultimo aggiornamento: ${date}.`,
            editeurTitre: 'Editore',
            editeurTexte: 'Repère — forma giuridica, sede legale, numero di registrazione e direttore della pubblicazione da completare.',
            hebergementTitre: 'Hosting',
            hebergementTexte: 'Il sito e il servizio sono ospitati in Francia. Nessun dato viene trasferito fuori dall’Unione europea.',
            contactTitre: 'Contatto',
            contactTexte: 'Indirizzo di contatto da completare.',
            proprieteTitre: 'Proprietà intellettuale',
            proprieteTexte: 'Il marchio Repère, il suo logo e il contenuto di questo sito sono protetti. È vietata qualsiasi riproduzione senza autorizzazione.',
        },
    },
    notifications: {
        libelles: {
            message_new: { un: 'un nuovo messaggio', plusieurs: (n) => `${n} nuovi messaggi` },
            proposal_new: {
                un: 'una nuova richiesta di accordo',
                plusieurs: (n) => `${n} nuove richieste di accordo`,
            },
            proposal_answered: {
                un: 'una risposta a una richiesta di accordo',
                plusieurs: (n) => `${n} risposte a richieste di accordo`,
            },
            expense_new: { un: 'una nuova spesa', plusieurs: (n) => `${n} nuove spese` },
            document_new: { un: 'un nuovo documento', plusieurs: (n) => `${n} nuovi documenti` },
            calendar_event_new: {
                un: 'un nuovo elemento nel calendario',
                plusieurs: (n) => `${n} nuovi elementi nel calendario`,
            },
            alert_new: { un: 'un avviso', plusieurs: (n) => `${n} avvisi` },
            professional_invited: {
                un: 'un accesso professionale aperto',
                plusieurs: (n) => `${n} accessi professionali aperti`,
            },
            writing_opened: {
                un: 'la scrittura aperta su un fascicolo',
                plusieurs: (n) => `la scrittura aperta su ${n} fascicoli`,
            },
        },
        enumeration: (morceaux) => morceaux.length <= 1
            ? (morceaux[0] ?? '')
            : `${morceaux.slice(0, -1).join(', ')} e ${morceaux.at(-1)}`,
    },
    mail: {
        verification: {
            objet: 'Confermate il vostro indirizzo e-mail',
            texte: (lien) => [
                'Ciao,',
                '',
                'Per confermare il vostro indirizzo e-mail su Repère, aprite questo link:',
                lien,
                '',
                'Questo link è valido 24 ore. Se non siete voi ad aver fatto questa richiesta,',
                'potete ignorare questo messaggio: nessun account sarà attivato.',
                '',
                'Repère — organizzazione e serenità',
            ].join('\n'),
            titre: 'Confermate il vostro indirizzo e-mail',
            paragraphes: [
                'Ciao,',
                'Per confermare il vostro indirizzo e-mail su Repère, usate il pulsante qui sotto.',
            ],
            bouton: 'Confermo il mio indirizzo',
            note: 'Questo link è valido 24 ore. Se non siete voi ad aver fatto questa richiesta, potete ignorare questo messaggio: nessun account sarà attivato.',
        },
        invitationDossier: {
            objet: 'Siete stati invitati a unirvi a un fascicolo su Repère',
            texte: (inviterName, lien) => [
                'Ciao,',
                '',
                `${inviterName} usa Repère per organizzare la vita quotidiana dei vostri figli`,
                'e vi propone di unirvi al fascicolo.',
                '',
                'Repère protegge i due genitori allo stesso modo: avrete esattamente gli',
                'stessi diritti, e la cronologia non appartiene a nessuno dei due. Nessuno può',
                'toglierne alcunché, né escludervi.',
                '',
                'Per unirvi al fascicolo:',
                lien,
                '',
                'Questo link è valido 30 giorni. Se preferite non usarlo, potete',
                'ignorare questo messaggio: non succederà nulla.',
                '',
                'Repère — organizzazione e serenità',
            ].join('\n'),
            titre: 'Siete stati invitati a unirvi a un fascicolo',
            paragraphes: (inviterName) => [
                'Ciao,',
                `${inviterName} usa Repère per organizzare la vita quotidiana dei vostri figli e vi propone di unirvi al fascicolo.`,
                'Repère protegge i due genitori allo stesso modo: avrete esattamente gli stessi diritti, e la cronologia non appartiene a nessuno dei due. Nessuno può toglierne alcunché, né escludervi.',
            ],
            bouton: 'Unirmi al fascicolo',
            note: 'Questo link è valido 30 giorni. Se preferite non usarlo, potete ignorare questo messaggio: non succederà nulla.',
        },
        digest: {
            objet: 'Novità nel vostro fascicolo Repère',
            texte: (resume, webUrl) => [
                'Ciao,',
                '',
                `Il vostro fascicolo Repère contiene ${resume}.`,
                '',
                'Per consultarlo:',
                webUrl,
                '',
                'Potete regolare le vostre ore silenziose e la frequenza di questi messaggi',
                'nelle preferenze del vostro account.',
                '',
                'Repère — organizzazione e serenità',
            ].join('\n'),
            titre: 'Novità nel vostro fascicolo',
            paragraphes: (resume) => ['Ciao,', `Il vostro fascicolo Repère contiene ${resume}.`],
            bouton: 'Apri il mio fascicolo',
            note: 'Potete regolare le vostre ore silenziose e la frequenza di questi messaggi nelle preferenze del vostro account.',
        },
        alerte: {
            objetUrgent: 'Allarme urgente sul vostro fascicolo Repère',
            objetNormal: 'Allarme sul vostro fascicolo Repère',
            texte: (motif, webUrl) => [
                'Ciao,',
                '',
                `È stato depositato un allarme nel vostro fascicolo Repère, con motivo «${motif}».`,
                '',
                'Per leggerlo:',
                webUrl,
                '',
                'Repère — organizzazione e serenità',
            ].join('\n'),
            titreUrgent: 'Allarme urgente sul vostro fascicolo',
            titreNormal: 'Allarme sul vostro fascicolo',
            paragraphes: ['Ciao,', 'È stato depositato un allarme nel vostro fascicolo Repère.'],
            encart: (motif) => `Motivo indicato: «${motif}»`,
            bouton: "Leggi l'allarme",
        },
        invitationPro: {
            objet: 'Vi è stato aperto un accesso professionale su Repère',
            texte: (modules, url) => [
                'Ciao,',
                '',
                'Un genitore vi ha aperto un accesso in consultazione al proprio fascicolo Repère.',
                '',
                `Vedrete: ${modules}.`,
                '',
                'Questo accesso è di sola lettura: non scrivete nulla, e nulla di ciò che',
                'consultate viene modificato dal vostro passaggio. Le vostre consultazioni sono',
                'registrate nel registro del fascicolo, che entrambi i genitori possono leggere.',
                'Ciascuno dei due genitori può porvi fine in qualsiasi momento.',
                '',
                'È gratuito e senza impegno. Per ritrovarlo:',
                url,
                '',
                'Repère — organizzazione e serenità',
            ].join('\n'),
            titre: 'Vi è stato aperto un accesso professionale',
            paragraphes: (modules) => [
                'Ciao,',
                'Un genitore vi ha aperto un accesso in consultazione al proprio fascicolo Repère.',
                `Vedrete: ${modules}.`,
                'Questo accesso è di sola lettura: non scrivete nulla, e nulla di ciò che consultate viene modificato dal vostro passaggio. Le vostre consultazioni sono registrate nel registro del fascicolo, che entrambi i genitori possono leggere. Ciascuno dei due genitori può porvi fine in qualsiasi momento.',
                'È gratuito e senza impegno.',
            ],
            bouton: 'Apri il mio accesso',
        },
        lienPaiement: {
            objet: 'Il suo link per abbonarsi a Repère',
            texte: (lien) => [
                'Buongiorno,',
                '',
                'Ha appena chiesto di abbonarsi dall’applicazione Repère.',
                'Apra questo link per concludere, su questo dispositivo o su un altro:',
                lien,
                '',
                'Questo link è valido 1 ora. Trascorso tale termine, lo richieda dall’applicazione.',
                'Non le viene addebitato nulla finché non conferma.',
                '',
                '— Repère',
            ].join('\n'),
            titre: 'Concludere l’abbonamento',
            paragraphes: [
                'Ha appena chiesto di abbonarsi dall’applicazione. Il pagamento si conclude qui, su questo dispositivo o su un altro.',
                'Non le viene addebitato nulla finché non conferma.',
            ],
            bouton: 'Concludere il pagamento',
            note: 'Questo link è valido 1 ora. Trascorso tale termine, lo richieda dall’applicazione.',
        },
        reinitialisation: {
            objet: 'Reimpostazione della vostra password',
            texte: (lien) => [
                'Ciao,',
                '',
                'Avete richiesto di reimpostare la vostra password Repère. Aprite questo link:',
                lien,
                '',
                'Questo link è valido 1 ora e funziona una sola volta.',
                'Se non siete voi ad aver fatto questa richiesta, ignorate questo messaggio:',
                'la vostra password attuale resta valida.',
                '',
                'Repère — organizzazione e serenità',
            ].join('\n'),
            titre: 'Reimpostazione della vostra password',
            paragraphes: ['Ciao,', 'Avete richiesto di reimpostare la vostra password Repère.'],
            bouton: 'Reimposta la mia password',
            note: 'Questo link è valido 1 ora e funziona una sola volta. Se non siete voi ad aver fatto questa richiesta, ignorate questo messaggio: la vostra password attuale resta valida.',
        },
        suppressionDossier: {
            objet: "Un'eliminazione di fascicolo attende la vostra conferma",
            texte: (demandeur, lien) => [
                'Buongiorno,',
                '',
                demandeur
                    ? `${demandeur} ha chiesto l'eliminazione di un fascicolo Repère che condividete.`
                    : "Avete chiesto l'eliminazione di uno dei vostri fascicoli Repère.",
                '',
                "Per ora non è stato eliminato nulla. L'eliminazione si conferma da questo link:",
                lien,
                '',
                'Una volta confermata, il fascicolo resta consultabile per trenta giorni senza',
                'poter essere modificato, poi viene distrutto definitivamente. In quel periodo può',
                "essere annullata in qualsiasi momento, dall'uno come dall'altro.",
                '',
                'Questo link è valido 7 giorni. Senza risposta, la richiesta si annulla da sé e il',
                'fascicolo resta intatto.',
                '',
                'Repère — organizzazione e serenità',
            ].join('\n'),
            titre: "Un'eliminazione di fascicolo attende la vostra conferma",
            paragraphes: (demandeur) => [
                'Buongiorno,',
                demandeur
                    ? `${demandeur} ha chiesto l'eliminazione di un fascicolo Repère che condividete.`
                    : "Avete chiesto l'eliminazione di uno dei vostri fascicoli Repère.",
                "Per ora non è stato eliminato nulla. Una volta confermata, l'eliminazione lascia il fascicolo consultabile per trenta giorni senza poter essere modificato, poi viene distrutto definitivamente. In quel periodo può essere annullata in qualsiasi momento, dall'uno come dall'altro.",
            ],
            bouton: 'Aprire la richiesta',
            note: 'Questo link è valido 7 giorni. Senza risposta, la richiesta si annulla da sé e il fascicolo resta intatto.',
        },
    },
    mobile: {
        notifications: {
            verification: 'Notifiche: verifica in corso…',
            pretes: 'Notifiche pronte su questo dispositivo.',
            refusees: 'Avete rifiutato le notifiche. Potete riattivarle nelle impostazioni del telefono.',
            indisponiblesTitre: 'Notifiche non disponibili',
            appareilRattacheTitre: 'Dispositivo registrato',
            appareilActif: 'Questo dispositivo è registrato. Sarete avvisati anche ad app chiusa.',
            appareilInactif: "Avete effettuato l'accesso, ma questo dispositivo non può ancora essere avvisato.",
        },
        dossiers: {
            titre: 'I vostri fascicoli',
            chargement: 'Caricamento…',
            erreur: 'Impossibile caricare i vostri fascicoli.',
            aucun: "Nessun fascicolo per ora. Potete crearne uno dall'applicazione web.",
            deconnexion: 'Disconnettersi',
            ouvrirIndice: 'Apre il calendario di questo fascicolo',
        },
        calendrier: {
            retour: 'Indietro',
            aujourdHui: 'Oggi',
            jusqua: (heure) => `Fino alle ${heure}`,
        },
    },
};
//# sourceMappingURL=it.js.map